import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter } from "react-router";
import { RouterProvider } from "react-router/dom";

import { rotas } from "./app/rotas";
import "./app/global.css";

// Created here, not in rotas.tsx: a browser router starts its loaders as soon as it exists,
// so importing the routes (as the tests do) must not create one.
const router = createBrowserRouter(rotas);

const raiz = document.getElementById("raiz");
if (!raiz) throw new Error("elemento #raiz ausente no index.html");

createRoot(raiz).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
